import { Project } from "@/types/project";
import { useState } from "react";
import ProjectCard from "../projects/ProjectCard";
import { PROJECTS } from "@/lib/constants";



const Projects = () => {
  const [imagesLoaded, setImagesLoaded] = useState<Record<string, boolean>>({});
  const [hoveredId, setHoveredId] = useState<string | null>(null);

  const handleImageLoad = (id: string) => {
    setImagesLoaded(prev => ({ ...prev, [id]: true }));
  };

  return (
    <section id="projects" className="py-32 md:py-20 bg-gray-50">
      <div className="container px-4 md:px-6">
        <div className="text-center mb-24 md:mb-40 animate-slide-down">
          <h2 className="mt-4 text-3xl md:text-4xl font-bold">
            Des projets <span className="text-orcsys-500">variés</span>
          </h2>
          <p className="mt-4 text-lg text-gray-600 max-w-2xl mx-auto">
            Découvrez quelques-uns des projets que nous avons réalisés pour nos clients.
          </p>
        </div>

        <div className="grid grid-cols-1 gap-40 max-w-5xl mx-auto">
          {PROJECTS.slice(0, 2).map((project, index) => (
            <ProjectCard
              key={project.id}
              project={project as Project}
              index={index}
              onMouseEnter={setHoveredId}
              onMouseLeave={() => setHoveredId(null)}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default Projects;
